import apiClient from './apiService';

const DEFAULT_THEME = {
  text: { primary: 'rgba(255, 255, 255, 1)' },
  button: {
    text: 'rgba(255, 255, 255, 1)',
    background: 'rgba(255, 255, 255, 0)',
    border: { color: 'rgba(255, 255, 255, 1)', width: '1px' },
  },
  background: {
    gradient: { left: 'rgba(58, 97, 134, 1)', right: 'rgba(137, 37, 62, 1)' },
  },
};

export const fetchProfile = () => apiClient.get('/profile/get');

export const normalizeProfileData = (result) => {
  let links;
  if (!result.links?.length) {
    links = [{
      id_link: parseInt(Math.floor(Math.random() * Date.now()).toString().slice(0, 5)),
      social_url: '',
      position: 0,
      social_name: "link",
      icon_name: "FaLink",
      icon_id: 13,
    }];
  } else {
    links = [...result.links].sort((a, b) => a.position - b.position);
  }
  return {
    links,
    theme: result.theme ?? DEFAULT_THEME,
    info: result.info ?? { title: '', description: '' },
    isPublished: result.isPublished ?? false,
    publishDate: result.publishDate ?? null,
  };
};
